import { render, staticRenderFns } from "./videoComponent.vue?vue&type=template&id=71347a42&scoped=true"
import script from "./videoComponent.vue?vue&type=script&lang=js"
export * from "./videoComponent.vue?vue&type=script&lang=js"
import style0 from "./videoComponent.vue?vue&type=style&index=0&id=71347a42&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71347a42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71347a42')) {
      api.createRecord('71347a42', component.options)
    } else {
      api.reload('71347a42', component.options)
    }
    module.hot.accept("./videoComponent.vue?vue&type=template&id=71347a42&scoped=true", function () {
      api.rerender('71347a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zdy_dragging/component/left/videoComponent.vue"
export default component.exports